import React from 'react';
import { CellProps } from 'react-table';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import classNames from 'classnames';
import styles from '../assets/districts-actions.module.scss';
import { IDistrict } from 'src/types/district';
import DeleteDistrictAction from './DeleteDistrictAction';

const DistrictActionsColumn: React.FunctionComponent<CellProps<IDistrict>> = ({
    cell: {
        row: { original },
    },
}: CellProps<IDistrict>) => {
    return (
        <div className={classNames(styles.actions, 'd-flex')}>
            <Link to={Router.generate(routes.DISTRICT_EDIT, { id: original.id })} className="btn btn-info  mr-2">
                <FontAwesomeIcon icon={faPencilAlt} />
            </Link>
            <DeleteDistrictAction data={original} />
        </div>
    );
};

export default DistrictActionsColumn;
